import useClickOutside from "@hooks/useClickOutside"
import { useRef } from "react"
import { SModal } from "./index.styled"
import { IModal } from "./types"
import close from '@icons/close.svg'

const Modal: React.FC<IModal> = ({ setModalOpen, children, header }) => {
    const modalRef = useRef<HTMLDivElement>(null)
    useClickOutside(modalRef, ()=>setModalOpen(false))
    return (
        <SModal ref={modalRef}>
            <div className="modal-header">
                <h2>{header}</h2>
                <div className="close-container">
                    <img onClick={()=>setModalOpen(false)} src={close} alt="close" />
                </div>
            </div>
            {children}
        </SModal>
    )
}

export default Modal